import { render } from "./ModuleUnit3.vue?vue&type=template&id=42e1af8f"
import script from "./ModuleUnit3.vue?vue&type=script&lang=js"
export * from "./ModuleUnit3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__